export const finalizeBodyData = <P>(isFormData: boolean, postData: P): string | FormData => {
  if (isFormData) {
    const formData = new FormData();
    for (const key in postData) {
      formData.append(key, postData[key] as string | Blob);
    }
    return formData;
  }
  return JSON.stringify(postData);
};
